import lottie, { AnimationItem } from 'lottie-web';
import React from 'react';

type Optional<T> = T | null;

type Player = AnimationItem;

class LoadingMessage extends React.Component {
    divRef: Optional<HTMLDivElement> = null;
    player: Optional<Player> = null;

    acquireRef(ref: Optional<HTMLDivElement>) {
        this.divRef = ref;
    }

    componentDidMount() {
        if (!this.divRef) {
            return;
        }

        this.player = lottie.loadAnimation({
            container: this.divRef,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: require('@/assets/animations/typing.json'),
        });
    }

    render() {
        return (
            <div
                className="loading-message"
                ref={this.acquireRef.bind(this)}
                style={{
                    width: '100px',
                    height: '30px',
                }}
            />
        );
    }
}

export default LoadingMessage;
